import React from "react";


export const MasterIcon = ({ size = 18, color = "#22c55e" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
  </svg>
);

export const MusicIcon = ({ size = 18, color = "#4DB8B5" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

export const SfxIcon = ({ size = 18, color = "#F59E0B" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2l2.5 7.5L22 12l-7.5 2.5L12 22l-2.5-7.5L2 12l7.5-2.5L12 2z" />
  </svg>
);

export const CHANNELS = [
  { key: "master", label: "Master", icon: <MasterIcon size={16} color="#22c55e" /> },
  { key: "music",  label: "Music",  icon: <MusicIcon size={16} color="#4DB8B5" /> },
  { key: "sfx",    label: "SFX",    icon: <SfxIcon size={16} color="#F59E0B" /> },
];

export const AUDIO_DEFAULT_STATE = {
  master: { volume: 1, muted: false },
  music:  { volume: 1, muted: false },
  sfx:    { volume: 1, muted: false },
};